import type { GameState } from '../state/gameState';

/** Gentle goals/quests — checked against current state, claimed once for a reward. */
export interface Goal {
  id: string;
  name: string;
  desc: string;
  reward: { gold?: number; item?: string; qty?: number };
  done: (s: GameState) => boolean;
  progress?: (s: GameState) => string;
}

// Rewards are EXCLUSIVE decorations — only obtainable here, never in the shop.
export const GOALS: Goal[] = [
  {
    id: 'harvest10', name: 'Green Thumb', desc: 'Harvest 10 crops', reward: { item: 'gnome' },
    done: (s) => s.stats.cropsHarvested >= 10, progress: (s) => `${Math.min(10, s.stats.cropsHarvested)}/10`,
  },
  {
    id: 'earn500', name: 'Market Day', desc: 'Earn 500g shipping', reward: { item: 'trophy' },
    done: (s) => s.stats.totalEarned >= 500, progress: (s) => `${Math.min(500, s.stats.totalEarned)}/500g`,
  },
  {
    id: 'chicken', name: 'Cluck Cluck', desc: 'Raise a chicken', reward: { item: 'wind_chime' },
    done: (s) => s.animals.some((a) => a.type === 'chicken'),
  },
  {
    id: 'cow', name: 'Moo Crew', desc: 'Raise a cow', reward: { item: 'star_banner' },
    done: (s) => s.animals.some((a) => a.type === 'cow'),
  },
  {
    id: 'tree', name: 'Orchard Start', desc: 'Plant an apple tree', reward: { item: 'golden_statue' },
    done: (s) => s.decorations.some((d) => d.decoId === 'apple_sapling'),
  },
  {
    id: 'decorate', name: 'Homemaker', desc: 'Place 5 decorations', reward: { item: 'fairy_lights' },
    done: (s) => s.decorations.length >= 5, progress: (s) => `${Math.min(5, s.decorations.length)}/5`,
  },
  {
    id: 'sheep', name: 'Wooly', desc: 'Raise a sheep', reward: { gold: 120 },
    done: (s) => s.animals.some((a) => a.type === 'sheep'),
  },
  {
    id: 'barn', name: 'Full Barn', desc: 'Own a chicken, cow & sheep', reward: { item: 'weathervane' },
    done: (s) => ['chicken', 'cow', 'sheep'].every((t) => s.animals.some((a) => a.type === t)),
  },
  {
    id: 'tycoon', name: 'Tycoon', desc: 'Earn 2000g shipping', reward: { item: 'fountain' },
    done: (s) => s.stats.totalEarned >= 2000, progress: (s) => `${Math.min(2000, s.stats.totalEarned)}/2000g`,
  },
  {
    id: 'week', name: 'Settling In', desc: 'Reach day 14', reward: { gold: 300 },
    done: (s) => s.clock.day >= 14, progress: (s) => `Day ${Math.min(14, s.clock.day)}/14`,
  },
];
